import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ex-notification-familiarize-action',
  templateUrl: './ex-notification-familiarize-action.component.html',
  styleUrls: ['./ex-notification-familiarize-action.component.css']
})
export class ExNotificationFamiliarizeActionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/auth/signin/ex-notification-familiarize-action/ex-notification-familiarize-action.component.ts